export const AssetGroupIcon = ({
  className = 'w-4 h-4',
}: {
  className?: string;
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 9.12828V12.5568M11 9.12828L14.5 7.41399M11 9.12828L7.5 7.41399M11 12.5568L14.5 10.8426V7.41399M11 12.5568L7.5 10.8426V7.41399M14.5 7.41399L11 5.69971L7.5 7.41399"
      stroke="currentColor"
    />
    <path
      d="M7.5 3.98521V7.41378M7.5 3.98521L11 2.27093M7.5 3.98521L4 2.27093M7.5 7.41378L11 5.6995V2.27093M7.5 7.41378L4 5.6995V2.27093M11 2.27093L7.5 0.556641L4 2.27093"
      stroke="currentColor"
    />
    <path
      d="M4 9.12828V12.5568M4 9.12828L7.5 7.41399M4 9.12828L0.5 7.41399M4 12.5568L7.5 10.8426V7.41399M4 12.5568L0.5 10.8426V7.41399M7.5 7.41399L4 5.69971L0.5 7.41399"
      stroke="currentColor"
    />
  </svg>
);
